import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * After ERP redirects here with JWT query params (`main.ts` stores them), map `/auth/me` into
 * legacy `localStorage.user` so existing marketing pages keep working.
 */
@Injectable({ providedIn: 'root' })
export class PortalSessionSyncService {
  constructor(private http: HttpClient) {}

  hydrateLegacyUserFromToken(): Promise<void> {
    const token = localStorage.getItem('mootori_access_token')?.trim();
    if (!token) {
      return Promise.resolve();
    }
    return lastValueFrom(
      this.http.get<{ success: boolean; data?: { user: unknown } }>(`${environment.authUrl}/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Api-Key': environment.APIKEY
        }
      })
    )
      .then((r) => {
        if (r?.success && r.data?.user != null) {
          localStorage.setItem('user', JSON.stringify(r.data.user));
          localStorage.setItem('loginby', 'ERP');
        }
      })
      .catch(() => undefined);
  }
}
